import styled from 'styled-components';

import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

export const TermsOfServiceStyle = styled.main`

  background-color: ${colors.white};
  width: 100%;
  box-sizing: border-box; 

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: 30px 40px;
  }

  .terms-of-service-section {
    background-color: ${colors.white};
    border-radius: 20px;
    padding: 40px 44px;

    .terms-of-service-content {
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
      }
      .terms-of-service-head {
        .terms-of-service-head-title {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.softBlue};
          font-size: 30px;
          line-height: 36px;
          margin-bottom: 8px;
        }

        .terms-of-service-head-description {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGray};
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 30px; 
        }
      }

     .terms-of-service-container {
        background-color: #FFFFFF;
        border: 1px solid #95A1B4;
        border-radius: 20px;
        padding: 7px;
        max-height: 60vh; 
        height: auto;
        overflow-y: auto; 
        
        .terms-of-service-container-content{
          padding: 10px;
          height: 100%; 
          box-sizing: border-box;
          
          .terms-of-service-container-description {
            ${fontFamily.sourceSansPro.regular};
            color: #95A1B4;
            font-size: 14px;
            line-height: 20px;
          }

          &::-webkit-scrollbar {
            width: 0.5em;
            height: 0.5em;
          }
        
          &::-webkit-scrollbar-thumb {
            background-color: ${colors.softBlue};
            border-radius: 20px;
            background-clip: padding-box;
          }
        }
      }

      .forgot-password,
      .go-to-login {
        display: none;
      }
    }
  }
`;